import Super from 'client-portal/routes/-request/information/review';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetInformationReview extends Super {}
